jQuery( document ).ready( function ( $ ) {
	if ( $( ".block-main-industry-recognition" ).length ) {

		$('.recognition-description').each(function (  ){
			if (!$(this).hasClass('unseen')) {
				$( this )[0].scrollIntoView({ block: "center" });
			}
		})

		if ($(body).attr('data-zoom') > 12 )  {
			$('.block-main-industry-recognition').addClass('middle-size');
		} else {
			removeClassFunction('.block-main-industry-recognition', 'middle-size');
		}

		if ($(body).hasClass('without-animation')) {
			$('.recognition-list-item').each(function(){
				$(this).addClass('non-animation');
			})
			$('.recognition-description').each(function(){
				$(this).addClass('non-animation');
			})
		}


		let topPosition;
		$('.recognition-list-item ').each(function (  ){
			let idForDescription = $(this).attr('id');
			if ($(this).attr('id') == idForDescription ) {
				topPosition = $(this);
			}
			$('.recognition-description.right-position.unseen').each(function (  ){
				if ($(this).attr(`data-id`) == idForDescription) {
					let top = Math.round($(topPosition).position().top);
					$(this).css({'transform-origin': `right ${top}px`});
				}
			})
			$('.recognition-description.left-position.unseen').each(function (  ){
				if ($(this).attr(`data-id`) == idForDescription) {
					let top = Math.round($(topPosition).position().top);
					$(this).css({'transform-origin': `left ${top}px`});
				}
			})
		})

		$( ".recognition-wrapper" ).on( "click", function ( event ) {

			if (event.target.tagName == 'A') {

				let clickElement = event.target;
				let id = $( clickElement ).attr( 'href' ),
					top = $( id ).offset().top - 80;

				$( 'body,html' ).animate( {scrollTop: top}, 1500 );
				removeClassFunction('.tab-item', 'active');
				$( clickElement ).addClass( 'active' );
			}

			if ($(event.target).hasClass('recognition-list-item') || $(event.target).parents('.recognition-list-item').length) {
				let idForOpenDescription = event.target.getAttribute('id') || $(event.target).parents('.recognition-list-item').get(0).getAttribute('id');
				$('.recognition-description').addClass('unseen');
				removeClassFunction($('.recognition-list-item'), 'absolute');
				$('.recognition-description').each(function ( ){

					if ($(this).attr(`data-id`) == idForOpenDescription) {
						removeClassFunction($(this), 'unseen');
						if ($(event.target).hasClass('recognition-list-item')) {
							event.target.classList.add('absolute');
						} else if ($(event.target).parents('.recognition-list-item').length) {
							let parent = $(event.target).parents('.recognition-list-item')[0];
							parent.classList.add('absolute');
						}

					}
				})
			}

			if (event.target.classList.contains('close-button') ) {
				let clickElement = $(event.target).parent('.recognition-description').get(0);
				$(clickElement).addClass('unseen');
				let currentID = $(clickElement).attr(`data-id`);

				$('.recognition-list-item').each(function (  ){
					if ($(this).attr('id') == currentID) {
						removeClassFunction($(this), 'absolute');
					}
				})
			}

		} );

		(function(){
			let speed = 2; // Скорость скролла.

			if (document.querySelector('.recognition-tabs')) {
				let scroll = document.querySelector('.recognition-tabs');
				let left = 0; // отпустили мышку - сохраняем положение скролла
				let drag = false;
				let coorX = 0; // нажали мышку - сохраняем координаты.


				scroll.addEventListener('mousedown', function(e) {
					drag = true;
					coorX = e.pageX - this.offsetLeft;

				});
				document.addEventListener('mouseup', function() {
					drag = false;
					left = scroll.scrollLeft;

				});
				scroll.addEventListener('mousemove', function(e) {

					if (drag) {
						this.scrollLeft = left - (e.pageX - this.offsetLeft - coorX)*speed;
					}
				});
			}

		})();

		const options = {
			root: null,
			threshold: 0,
			rootMargin: '-10% 0px -85% 0px',
		};

		const callback = function ( entries, observer ) {
			entries.forEach( entry => {
				if ( entry.isIntersecting ) {
					let blockNumber = entry.target.getAttribute('data-number');

					removeClassFunction('.tab-item', 'active');

					$( '.tab-item' ).each(function ( elem ) {
						if ($( this ).attr(`href`) == `#${blockNumber}`) {
							$( this ).addClass( 'active' );
							if (window.innerWidth < 800) {
								$( this )[0].scrollIntoView();
							}
							// $( this )[0].scrollIntoView();
						}
					})
				}
			} );

		};
		let recognitionBlock = document.querySelectorAll('.recognition-list');
		const observer = new IntersectionObserver( callback, options );
		recognitionBlock.forEach( listItem => {
			observer.observe( listItem );
		} )

		function removeClassFunction(itemsArray, currentClass) {
			$( itemsArray ).each( function ( item ) {
				if ( $( this ).hasClass( currentClass ) ) {
					$( this ).removeClass( currentClass )
				}
			} )
		}

		$(document).on('accessibilityPreEvent', function (e) {
			if (e.originalEvent.detail['counter'] > 12) {
				$('.block-main-industry-recognition').addClass('middle-size');
			} else {
				removeClassFunction('.block-main-industry-recognition', 'middle-size');
			}
			if (e.originalEvent.detail['without-animation']) {
				$('.recognition-list-item').each(function(){
					$(this).addClass('non-animation');
				})
				$('.recognition-description').each(function(){
					$(this).addClass('non-animation');
				})
			} else {
				$('.recognition-list-item').each(function(){
					removeClassFunction(this, 'non-animation');
				})
				$('.recognition-description').each(function(){
					removeClassFunction(this, 'non-animation');
				})
			}
		});
	}

})
